import React, { forwardRef, Fragment } from "react";
import useTheme from "@material-ui/core/styles/useTheme";
import Paper from "@material-ui/core/Paper";
import MaterialTable from "material-table";

import AddBox from "@material-ui/icons/AddBox";
import ArrowDownward from "@material-ui/icons/ArrowDownward";
import Check from "@material-ui/icons/Check";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Clear from "@material-ui/icons/Clear";
import DeleteOutline from "@material-ui/icons/DeleteOutline";
import Edit from "@material-ui/icons/Edit";
import FilterList from "@material-ui/icons/FilterList";
import FirstPage from "@material-ui/icons/FirstPage";
import LastPage from "@material-ui/icons/LastPage";
import Remove from "@material-ui/icons/Remove";
import SaveAlt from "@material-ui/icons/SaveAlt";
import Search from "@material-ui/icons/Search";
import ViewColumn from "@material-ui/icons/ViewColumn";

export const URLGenerator = (query, path) => {

    let url = `${path}?itemsPerPage=${query.pageSize}&pageNumber=${query.page + 1}`

    query.filters.forEach(f => {
        if(f.value.constructor == Array) {
            f.value.forEach(fv => {
                url = url + `&${f.column.field}=${fv}`
            })
        } else {
            url = url + `&${f.column.field}=${f.value}`
        }
    })

    return url;
}

export const FingotiTable = ({
    actions,
    columns,
    components,
    data,
    icons,
    localization,
    options,
    style,
    tableRef,
    title = "",
    ...rest
}) => {

    const theme = useTheme();

    const tableIcons = {
        Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
        Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
        Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
        DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
        Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
        Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
        FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
        LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
        NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
        PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
        ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
        Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
        SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
        ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
        ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
        ...icons
    }

    return (
        <MaterialTable
            actions={actions}
            columns={columns}
            components={{
                Toolbar: () => <Fragment></Fragment>,
                Container: props => <Paper {...props} elevation={0} />,
                ...components
            }}
            data={data}
            icons={tableIcons}
            localization={{
                header: {
                    actions: "actions"
                },
                ...localization
            }}
            options={{
                search: false,
                sorting: false,
                headerStyle: { color: theme.palette.primary.main },
                pageSize: 10,
                pageSizeOptions: [10, 25, 50],
                actionsColumnIndex: -1,
                filtering: true,
                ...options
            }}
            style={style}
            tableRef={tableRef}
            title={title}
            {...rest}
        />
    );

}